import { CsProductCardsProduct, CsProductCardsSection } from '../../../types';
import { ProductCardsProps } from '@raisin/components-lib';

export const createSectionParser =
  (dependencies: {
    productMapper: (
      product: CsProductCardsProduct,
    ) => ProductCardsProps['sections'][number]['products'][number] | undefined;
  }) =>
  (value: CsProductCardsSection) =>
    ({
      id: value.section_id,
      title: value.title,
      products: value.products.map(dependencies.productMapper),
    } as ProductCardsProps['sections'][number]);
